<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="funderPrograms"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  to="/manage/edit/funderProgram/add"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
            </v-dialog>
          </v-toolbar>
        </template>
        <template
          v-slot:item.name="{ item }"
        >
          <span v-if="item.name['gl'] !== '' && item.name['gl'] !== undefined">{{item.name['gl']}}</span>
          <span v-else-if="item.name['es'] !== '' && item.name['es'] !== undefined">{{item.name['es']}}</span>
          <span v-else>{{item.name['en']}}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            class="mr-2"
            color="primary"
            @click="$router.push('/manage/edit/funderProgram/edit/' + item.id)"
          >
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
export default {
  mixins: [validationRules],
  data() {
    return {
      dialog: false,
      search: "",
      funderPrograms: [],
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("table.name"),
          value: "name"
        },
        {
          text: this.$t("table.internal_name"),
          value: "internal_name"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          width: "15%",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/funderProgram";
      axios
        .get(path)
        .then(response => {
          this.funderPrograms = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/funderProgram/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.funderPrograms.indexOf(item);
            this.funderPrograms.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    }
  }
};
</script>
